<div class="modal-header card-header">
  <div class="col-md-8 col-xs-8">
    <span class="text-blue text-125">Certificados - {{campeonato.nombre}}</span>
  </div>
  <div class="col-md-4 col-xs-4 text-right">
    <button class="btn btn-danger" type="button" (click)="cerrarComponente()">
      <i class="fa fa-times red2 text-110 mr-1"></i>
    </button>
  </div>
</div>
<div class="modal-body card-body">
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item">
      <a class="nav-link" href="javascript:void(0)" [class.active]="pestana=='diseno'" (click)="pestana='diseno'">
        <i class="fas fa-pencil-ruler mr-1"></i>Diseño de plantillas
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="javascript:void(0)" [class.active]="pestana=='generar'" (click)="pestana='generar'">
        <i class="fas fa-file-pdf mr-1"></i>Generar certificados
      </a>
    </li>
  </ul>

  <!-- ===================== DISEÑO ===================== -->
  <div *ngIf="pestana=='diseno'" class="row">
    <!-- en pantallas angostas el lienzo va arriba: si no, el panel de propiedades que aparece al seleccionar lo correria a mitad del arrastre -->
    <div class="col-lg-4 col-xl-3 order-2 order-lg-1 cert-panel" [class.d-none]="panel_oculto">
      <div class="cert-grupo">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="mb-0 text-600">Plantillas</label>
          <div>
            <input #archivo_importacion type="file" accept=".json,application/json" class="d-none" (change)="importarPlantilla($event)" />
            <button class="btn btn-sm btn-outline-primary mr-1" type="button" title="Importar una plantilla exportada (.json)" (click)="archivo_importacion.click()">
              <i class="fa fa-file-import mr-1"></i>Importar
            </button>
            <button class="btn btn-sm btn-success" type="button" (click)="crearPlantilla()">
              <i class="fa fa-plus mr-1"></i>Nueva
            </button>
          </div>
        </div>
        <div *ngIf="plantillas.length==0" class="text-grey-m1">El campeonato todavía no tiene plantillas.</div>
        <div *ngFor="let p of plantillas" class="cert-plantilla" [class.activa]="plantilla && plantilla.id==p.id">
          <a href="javascript:void(0)" class="flex-grow-1" (click)="seleccionarPlantilla(p)">
            {{p.nombre}} <small class="text-grey-m1">({{tipoCertificado(p.tipo).nombre}})</small>
          </a>
          <a href="javascript:void(0)" class="text-danger ml-2" title="Eliminar" (click)="abrirPopupConfirmacionEliminacion(p)">
            <i class="fa fa-trash-alt"></i>
          </a>
        </div>
      </div>

      <ng-container *ngIf="plantilla">
        <div class="cert-grupo">
          <div class="row">
            <div class="col-12 mb-2">
              <label>Nombre</label>
              <input type="text" class="form-control form-control-sm" name="nombre_plantilla" [(ngModel)]="plantilla.nombre" />
            </div>
            <div class="col-6 mb-2">
              <label>Tipo</label>
              <select class="form-control form-control-sm" name="tipo_plantilla" [(ngModel)]="plantilla.tipo" (ngModelChange)="cambiarTipoPlantilla()">
                <option *ngFor="let t of tipos_certificado" [ngValue]="t.codigo">{{t.nombre}}</option>
              </select>
            </div>
            <div class="col-3 mb-2">
              <label>Papel</label>
              <select class="form-control form-control-sm" name="papel_plantilla" [(ngModel)]="plantilla.tamano_papel" (ngModelChange)="programarVistaPrevia(0)">
                <option ngValue="CARTA">Carta</option>
                <option ngValue="OFICIO">Oficio</option>
                <option ngValue="A4">A4</option>
              </select>
            </div>
            <div class="col-3 mb-2">
              <label>Orientación</label>
              <select class="form-control form-control-sm" name="orientacion_plantilla" [(ngModel)]="plantilla.orientacion" (ngModelChange)="programarVistaPrevia(0)">
                <option ngValue="HORIZONTAL">Horizontal</option>
                <option ngValue="VERTICAL">Vertical</option>
              </select>
            </div>
            <div class="col-12">
              <label>Fondo</label>
              <div class="d-flex align-items-center">
                <input type="file" accept="image/png,image/jpeg" class="form-control-file" (change)="subirFondo($event)" />
                <button *ngIf="plantilla.fondo" class="btn btn-xs btn-outline-danger ml-2" type="button" (click)="quitarFondo()">Quitar</button>
              </div>
              <small class="text-grey-m1">Hoja de {{medidasPagina(plantilla)[0] | number:'1.0-0'}} × {{medidasPagina(plantilla)[1] | number:'1.0-0'}} puntos. Las posiciones se miden desde la esquina superior izquierda.</small>
            </div>
          </div>
        </div>

        <div class="cert-grupo">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="mb-0 text-600">Elementos</label>
            <div>
              <button class="btn btn-xs btn-outline-primary mr-1" type="button" (click)="agregarElemento('texto')"><i class="fa fa-font mr-1"></i>Texto</button>
              <button class="btn btn-xs btn-outline-primary mr-1" type="button" (click)="agregarElemento('imagen')"><i class="fa fa-image mr-1"></i>Imagen</button>
              <button class="btn btn-xs btn-outline-primary mr-1" type="button" (click)="agregarElemento('linea')"><i class="fa fa-minus mr-1"></i>Línea</button>
              <button class="btn btn-xs btn-outline-primary" type="button" (click)="agregarElemento('marco')"><i class="far fa-square mr-1"></i>Marco</button>
            </div>
          </div>
          <div class="cert-elementos">
            <div *ngFor="let e of plantilla.elementos; let i=index; let ultimo=last" class="cert-elemento" [class.activa]="elemento===e">
              <a href="javascript:void(0)" class="flex-grow-1 text-truncate" (click)="elemento=e">{{descripcionElemento(e)}}</a>
              <a href="javascript:void(0)" class="ml-2" [class.invisible]="i==0" title="Subir" (click)="moverElemento(e,-1)"><i class="fa fa-arrow-up"></i></a>
              <a href="javascript:void(0)" class="ml-2" [class.invisible]="ultimo" title="Bajar" (click)="moverElemento(e,1)"><i class="fa fa-arrow-down"></i></a>
              <a href="javascript:void(0)" class="ml-2" title="Duplicar" (click)="duplicarElemento(e)"><i class="far fa-copy"></i></a>
              <a href="javascript:void(0)" class="ml-2 text-danger" title="Quitar" (click)="eliminarElemento(e)"><i class="fa fa-times"></i></a>
            </div>
          </div>
          <small class="text-grey-m1">Se dibujan en orden: los de abajo quedan encima.</small>
        </div>

        <div class="cert-grupo" *ngIf="elemento">
          <label class="text-600">Propiedades: {{elemento.tipo}}</label>
          <div class="row">
            <ng-container *ngIf="elemento.tipo=='texto'">
              <div class="col-12 mb-2">
                <textarea class="form-control form-control-sm" rows="3" name="contenido_elemento" [(ngModel)]="elemento.contenido" (ngModelChange)="programarVistaPrevia()"></textarea>
              </div>
              <div class="col-12 mb-2">
                <select class="form-control form-control-sm" name="variable_elemento" [ngModel]="null" (ngModelChange)="$event && insertarVariable($event)">
                  <option [ngValue]="null">Insertar variable...</option>
                  <option *ngFor="let v of variables" [ngValue]="v.codigo">{{v.codigo}} - {{v.nombre}}</option>
                </select>
              </div>
              <div class="col-6 mb-2">
                <label>Fuente</label>
                <select class="form-control form-control-sm" name="fuente_elemento" [(ngModel)]="elemento.fuente" (ngModelChange)="programarVistaPrevia(0)">
                  <optgroup label="Estándar">
                    <option *ngFor="let f of fuentes" [ngValue]="f">{{f}}</option>
                  </optgroup>
                  <optgroup label="Personalizadas" *ngIf="fuentes_personalizadas.length>0">
                    <option *ngFor="let f of fuentes_personalizadas" [ngValue]="f.nombre">{{f.nombre}}</option>
                  </optgroup>                </select>
              </div>
              <div class="col-3 mb-2">
                <label>Tamaño</label>
                <input type="number" min="4" class="form-control form-control-sm" name="tamano_elemento" [(ngModel)]="elemento.tamano" (ngModelChange)="programarVistaPrevia()" />
              </div>
              <div class="col-3 mb-2">
                <label>Alineación</label>
                <select class="form-control form-control-sm" name="alineacion_elemento" [(ngModel)]="elemento.alineacion" (ngModelChange)="programarVistaPrevia(0)">
                  <option ngValue="left">Izq.</option>
                  <option ngValue="center">Centro</option>
                  <option ngValue="right">Der.</option>
                  <option ngValue="justify">Just.</option>
                </select>
              </div>
              <div class="col-6 mb-2">
                <label>
                  <input type="checkbox" name="mayusculas_elemento" [(ngModel)]="elemento.mayusculas" (ngModelChange)="programarVistaPrevia(0)" /> Mayúsculas
                </label>
              </div>
              <div class="col-12 mb-2">
                <label>Curvatura <small class="text-grey-m1">(0 = recto, + hacia arriba, − hacia abajo)</small></label>
                <div class="d-flex align-items-center">
                  <input type="range" min="-100" max="100" step="1" class="flex-grow-1" name="curvatura_rango"
                         [ngModel]="elemento.curvatura || 0" (ngModelChange)="fijarCurvatura(elemento,$event)" />
                  <input type="number" min="-100" max="100" class="form-control form-control-sm cert-giro ml-2" name="curvatura_elemento"
                         [ngModel]="elemento.curvatura || 0" (ngModelChange)="fijarCurvatura(elemento,$event)" />
                  <button class="btn btn-xs btn-outline-secondary ml-1" type="button" title="Texto recto" [disabled]="!elemento.curvatura" (click)="elemento.curvatura=0; programarVistaPrevia()">0</button>
                </div>
                <small *ngIf="elemento.curvatura" class="text-grey-m1">El texto curvo va en una sola línea, centrado en la caja.</small>
              </div>
              <div class="col-6 mb-2">
                <label>Color del borde</label>
                <input type="color" class="form-control form-control-sm" name="borde_color_elemento" [ngModel]="elemento.borde_color || '#000000'"
                       (ngModelChange)="elemento.borde_color=$event; programarVistaPrevia()" />
              </div>
              <div class="col-6 mb-2">
                <label>Grosor del borde</label>
                <input type="number" min="0" max="10" step="0.25" class="form-control form-control-sm" name="borde_grosor_elemento"
                       [ngModel]="elemento.borde_grosor || 0" (ngModelChange)="fijarGrosorBorde(elemento,$event)" />
                <small class="text-grey-m1">0 = sin borde</small>
              </div>
            </ng-container>
            <ng-container *ngIf="elemento.tipo=='imagen'">
              <div class="col-12 mb-2">
                <label>Origen</label>
                <select class="form-control form-control-sm" name="origen_elemento" [(ngModel)]="elemento.origen" (ngModelChange)="programarVistaPrevia(0)">
                  <option *ngFor="let o of origenes_imagen" [ngValue]="o.codigo">{{o.nombre}}</option>
                </select>
              </div>
              <div class="col-12 mb-2" *ngIf="elemento.origen=='archivo'">
                <input type="file" accept="image/png,image/jpeg" class="form-control-file" (change)="subirImagenElemento($event)" />
                <small class="text-grey-m1">Para firmas y sellos use PNG con fondo transparente.</small>
              </div>
              <div class="col-12 mb-2">
                <label>Giro (grados)</label>
                <div class="d-flex align-items-center">
                  <button class="btn btn-xs btn-outline-secondary mr-1" type="button" title="Girar 90° a la izquierda" (click)="girarElemento(elemento,-90)">
                    <i class="fas fa-undo"></i>
                  </button>
                  <input type="number" min="-180" max="180" class="form-control form-control-sm cert-giro" name="rotacion_elemento"
                         [ngModel]="elemento.rotacion || 0" (ngModelChange)="elemento.rotacion=normalizarGiro($event); programarVistaPrevia()" />
                  <button class="btn btn-xs btn-outline-secondary ml-1" type="button" title="Girar 90° a la derecha" (click)="girarElemento(elemento,90)">
                    <i class="fas fa-redo"></i>
                  </button>
                  <button class="btn btn-xs btn-outline-secondary ml-1" type="button" title="Quitar el giro" [disabled]="!elemento.rotacion" (click)="elemento.rotacion=0; programarVistaPrevia()">
                    0°
                  </button>
                </div>
                <small class="text-grey-m1">En el lienzo también se gira con el asa redonda de arriba (con Mayús, de 15 en 15).</small>
              </div>
            </ng-container>
            <div class="col-3 mb-2">
              <label>X</label>
              <input type="number" class="form-control form-control-sm" name="x_elemento" [(ngModel)]="elemento.x" (ngModelChange)="programarVistaPrevia()" />
            </div>
            <div class="col-3 mb-2">
              <label>Y</label>
              <input type="number" class="form-control form-control-sm" name="y_elemento" [(ngModel)]="elemento.y" (ngModelChange)="programarVistaPrevia()" />
            </div>
            <div class="col-3 mb-2">
              <label>Ancho</label>
              <input type="number" min="1" class="form-control form-control-sm" name="ancho_elemento" [(ngModel)]="elemento.ancho" (ngModelChange)="programarVistaPrevia()" />
            </div>
            <div class="col-3 mb-2" *ngIf="elemento.tipo!='linea'">
              <label>Alto</label>
              <input type="number" min="0" class="form-control form-control-sm" name="alto_elemento" [(ngModel)]="elemento.alto" (ngModelChange)="programarVistaPrevia()" />
            </div>
            <div class="col-3 mb-2" *ngIf="elemento.tipo=='linea' || elemento.tipo=='marco'">
              <label>Grosor</label>
              <input type="number" min="0.5" step="0.5" class="form-control form-control-sm" name="grosor_elemento" [(ngModel)]="elemento.grosor" (ngModelChange)="programarVistaPrevia()" />
            </div>
            <div class="col-3 mb-2" *ngIf="elemento.tipo!='imagen'">
              <label>Color</label>
              <input type="color" class="form-control form-control-sm" name="color_elemento" [(ngModel)]="elemento.color" (ngModelChange)="programarVistaPrevia()" />
            </div>
          </div>
          <div class="d-flex align-items-center">
            <button class="btn btn-xs btn-outline-secondary mr-2" type="button" (click)="centrarHorizontal(elemento)">
              <i class="fas fa-arrows-alt-h mr-1"></i>Centrar en la hoja
            </button>
            <small *ngIf="elemento.tipo=='texto'" class="text-grey-m1">En el PDF, si el texto no entra en el alto se achica la letra; con alto 0 no se limita.</small>
          </div>
        </div>

        <div class="cert-grupo">
          <label class="text-600">Fuentes personalizadas (TTF/OTF)</label>
          <div *ngFor="let f of fuentes_personalizadas" class="cert-elemento">
            <span class="flex-grow-1" [ngStyle]="estiloFuente(f.nombre)">{{f.nombre}} - Certificado</span>
            <a href="javascript:void(0)" class="ml-2 text-danger" title="Eliminar" (click)="abrirPopupConfirmacionEliminacionFuente(f)"><i class="fa fa-trash-alt"></i></a>
          </div>
          <div class="row mt-2 align-items-end">
            <div class="col-5">
              <input type="file" accept=".ttf,.otf" class="form-control-file" (change)="seleccionarArchivoFuente($event)" />
            </div>
            <div class="col-4">
              <input type="text" class="form-control form-control-sm" name="nombre_fuente" [(ngModel)]="nueva_fuente.nombre" placeholder="Nombre" />
            </div>
            <div class="col-3">
              <button class="btn btn-xs btn-success" type="button" [disabled]="!nueva_fuente.archivo" (click)="guardarFuente()">
                <i class="fa fa-upload mr-1"></i>Subir
              </button>
            </div>
          </div>
          <small class="text-grey-m1">Son de la empresa: quedan disponibles en todas las plantillas.</small>
        </div>

        <div class="d-flex justify-content-between mb-3">
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="restablecerDiseno()">
            <i class="fa fa-undo mr-1"></i>Diseño por defecto
          </button>
          <div>
            <button class="btn btn-sm btn-outline-primary mr-1" type="button" title="Descargar la plantilla como archivo, con su fondo, imágenes y fuentes" (click)="exportarPlantilla()">
              <i class="fa fa-file-export mr-1"></i>Exportar
            </button>
            <button class="btn btn-sm btn-primary" type="button" (click)="guardarPlantilla()">
              <i class="fa fa-save mr-1"></i>Guardar plantilla
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="order-1 order-lg-2 cert-columna-lienzo" [ngClass]="panel_oculto?'col-12':'col-lg-8 col-xl-9'">
      <div *ngIf="!plantilla" class="cert-vacio">
        Seleccione una plantilla o cree una nueva para ver su diseño.
      </div>
      <ng-container *ngIf="plantilla">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn" [ngClass]="vista=='lienzo'?'btn-primary':'btn-outline-primary'" (click)="cambiarVista('lienzo')">
              <i class="fas fa-mouse-pointer mr-1"></i>Lienzo
            </button>
            <button type="button" class="btn" [ngClass]="vista=='pdf'?'btn-primary':'btn-outline-primary'" (click)="cambiarVista('pdf')">
              <i class="fas fa-file-pdf mr-1"></i>PDF
            </button>
          </div>
          <button type="button" class="btn btn-sm btn-outline-secondary ml-2" (click)="panel_oculto=!panel_oculto"
                  [title]="panel_oculto?'Mostrar el panel de plantillas y propiedades':'Ocultar el panel para que el lienzo ocupe toda la pantalla'">
            <i class="fas mr-1" [ngClass]="panel_oculto?'fa-compress-alt':'fa-expand-alt'"></i>{{panel_oculto?'Mostrar panel':'Ampliar lienzo'}}
          </button>
          <small class="text-grey-m1">
            Con datos de {{jugadores_equipo.length>0?jugadores_equipo[0].jugador.persona.nombre_completo:'un jugador de ejemplo'}}
            <span *ngIf="vista=='pdf' && vista_previa.generando" class="ml-2"><i class="fa fa-spinner fa-spin mr-1"></i>Dibujando...</span>
          </small>
        </div>

        <ng-container *ngIf="vista=='lienzo'">
          <div #contenedor_lienzo class="cert-lienzo-contenedor">
            <div class="cert-lienzo-marco"
                 [style.width.px]="medidasPagina(plantilla)[0]*escalaLienzo()"
                 [style.height.px]="medidasPagina(plantilla)[1]*escalaLienzo()">
              <div class="cert-lienzo" tabindex="0"
                   [style.width.px]="medidasPagina(plantilla)[0]"
                   [style.height.px]="medidasPagina(plantilla)[1]"
                   [style.transform]="'scale('+escalaLienzo()+')'"
                   (pointerdown)="elemento=null"
                   (keydown)="teclaLienzo($event)">
                <img *ngIf="plantilla.fondo" class="cert-fondo" [src]="urlImagenLienzo(plantilla.fondo)" alt="" draggable="false" />
                <ng-container *ngFor="let e of plantilla.elementos">
                  <div class="cert-el cert-el-{{e.tipo}}" [class.seleccionado]="elemento===e" [ngStyle]="estiloElemento(e)"
                       (pointerdown)="e.tipo!='marco' && iniciarArrastre($event,e,'mover')">
                    <ng-container [ngSwitch]="e.tipo">
                      <ng-container *ngSwitchCase="'texto'">
                        <div *ngIf="!e.curvatura" class="cert-texto">{{textoLienzo(e)}}</div>
                        <div *ngIf="e.curvatura" class="cert-texto-curvo">
                          <span *ngFor="let l of letrasTextoCurvo(e)" [ngStyle]="l.estilo">{{l.letra}}</span>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'imagen'">
                        <img *ngIf="urlImagenLienzo(rutaImagenElemento(e,jugadorVistaPrevia())) as src; else sin_imagen"
                             [src]="src" alt="" draggable="false" />
                        <ng-template #sin_imagen>
                          <div class="cert-imagen-vacia">{{descripcionElemento(e)}}</div>
                        </ng-template>
                      </ng-container>
                      <div *ngSwitchCase="'linea'" class="cert-linea" [ngStyle]="estiloLinea(e)"></div>
                      <ng-container *ngSwitchCase="'marco'">
                        <!-- el interior del marco no se agarra: asi se puede seleccionar lo que hay dentro -->
                        <div class="cert-borde cert-borde-arriba" (pointerdown)="iniciarArrastre($event,e,'mover')"></div>
                        <div class="cert-borde cert-borde-abajo" (pointerdown)="iniciarArrastre($event,e,'mover')"></div>
                        <div class="cert-borde cert-borde-izquierda" (pointerdown)="iniciarArrastre($event,e,'mover')"></div>
                        <div class="cert-borde cert-borde-derecha" (pointerdown)="iniciarArrastre($event,e,'mover')"></div>
                      </ng-container>
                    </ng-container>
                    <span *ngIf="elemento===e" class="cert-asa" title="Redimensionar"
                          [style.transform]="'scale('+(1/escalaLienzo())+')'"
                          (pointerdown)="iniciarArrastre($event,e,'redimensionar')"></span>
                    <ng-container *ngIf="elemento===e && e.tipo=='imagen'">
                      <span class="cert-asa-giro-linea" [style.height.px]="22/escalaLienzo()" [style.top.px]="-22/escalaLienzo()"></span>
                      <span class="cert-asa-giro" title="Girar"
                            [style.top.px]="-22/escalaLienzo()"
                            [style.transform]="'translate(-50%,-50%) scale('+(1/escalaLienzo())+')'"
                            (pointerdown)="iniciarArrastre($event,e,'girar')"></span>
                    </ng-container>
                  </div>
                </ng-container>
                <div *ngIf="guias.vertical" class="cert-guia cert-guia-vertical"></div>
                <div *ngIf="guias.horizontal" class="cert-guia cert-guia-horizontal"></div>
              </div>
            </div>
          </div>
          <small class="text-grey-m1">
            Arrastre para mover, use la esquina azul para cambiar el tamaño, y las flechas del teclado para ajustar
            (con Mayús, de 10 en 10). Las fuentes del lienzo son aproximadas: la pestaña PDF muestra el resultado exacto.
          </small>
        </ng-container>

        <ng-container *ngIf="vista=='pdf'">
          <div class="cert-aviso" *ngIf="vista_previa.mensaje">
            <i class="fas fa-info-circle text-blue mr-1"></i>{{vista_previa.mensaje}}
          </div>
          <pdf-viewer *ngIf="vista_previa.pdf && !vista_previa.mensaje"
                      class="cert-vista-previa"
                      [src]="vista_previa.pdf"
                      [render-text]="false"
                      [original-size]="false"
                      [show-all]="true"
                      [autoresize]="true"></pdf-viewer>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- ===================== GENERAR ===================== -->
  <div *ngIf="pestana=='generar'">
    <div class="row align-items-end">
      <div class="col-md-4 col-lg-2 mb-2">
        <label>Plantilla</label>
        <select class="form-control form-control-sm" name="plantilla_generacion" [(ngModel)]="generacion.id_plantilla">
          <option *ngFor="let p of plantillas" [ngValue]="p.id">{{p.nombre}}</option>
        </select>
      </div>
      <div class="col-md-4 col-lg-2 mb-2">
        <label>Mostrar</label>
        <select class="form-control form-control-sm" name="tipo_filtro" [(ngModel)]="filtro.tipo">
          <option ngValue="TODOS">Todos</option>
          <option ngValue="JUGADORES">Solo jugadores</option>
          <option ngValue="MANUALES">Solo personas agregadas ({{destinatarios_manuales.length}})</option>
        </select>
      </div>
      <div class="col-md-4 col-lg-2 mb-2">
        <label>Disciplina</label>
        <select class="form-control form-control-sm" name="disciplina_filtro" [(ngModel)]="filtro.id_disciplina" (ngModelChange)="cambiarDisciplina()">
          <option [ngValue]="null">Todas</option>
          <option *ngFor="let d of disciplinas" [ngValue]="d.id">{{d.nombre}}</option>
        </select>
      </div>
      <div class="col-md-4 col-lg-2 mb-2">
        <label>Categoría</label>
        <select class="form-control form-control-sm" name="categoria_filtro" [(ngModel)]="filtro.id_categoria" (ngModelChange)="cambiarCategoria()">
          <option [ngValue]="null">Todas</option>
          <option *ngFor="let c of categoriasFiltradas()" [ngValue]="c.id">{{c.nombre}}</option>
        </select>
      </div>
      <div class="col-md-6 col-lg-2 mb-2">
        <label>Equipo</label>
        <select class="form-control form-control-sm" name="equipo_filtro" [(ngModel)]="filtro.id_equipo">
          <option [ngValue]="null">Todos</option>
          <option *ngFor="let e of equiposFiltrados()" [ngValue]="e.id">{{e.nombre}}</option>
        </select>
      </div>
      <div class="col-md-6 col-lg-2 mb-2">
        <label>Buscar</label>
        <input type="text" class="form-control form-control-sm" name="texto_filtro" [(ngModel)]="filtro.texto" placeholder="Nombre" />
      </div>
    </div>

    <!-- personas que no son jugadores registrados: entrenadores, delegados... -->
    <div class="cert-grupo">
      <label class="text-600 mb-1"><i class="fas fa-user-plus mr-1"></i>Agregar persona (entrenador, delegado u otra que no esté registrada)</label>
      <div class="row align-items-end">
        <div class="col-md-6 col-lg-3 mb-2">
          <label>Nombre completo</label>
          <input type="text" class="form-control form-control-sm" name="nombre_persona" [(ngModel)]="nueva_persona.nombre"
                 placeholder="Ej.: Lic. Juan Pérez Mamani" (keyup.enter)="agregarDestinatarioManual()" />
        </div>
        <div class="col-md-6 col-lg-2 mb-2">
          <label>CI <small class="text-grey-m1">(opcional)</small></label>
          <input type="text" class="form-control form-control-sm" name="ci_persona" [(ngModel)]="nueva_persona.ci" />
        </div>
        <div class="col-md-6 col-lg-2 mb-2">
          <label>Cargo</label>
          <select class="form-control form-control-sm" name="cargo_persona" [(ngModel)]="nueva_persona.cargo">
            <option *ngFor="let c of cargos" [ngValue]="c">{{c}}</option>
            <option ngValue="OTRO">Otro...</option>
          </select>
        </div>
        <div class="col-md-6 col-lg-2 mb-2" *ngIf="nueva_persona.cargo=='OTRO'">
          <label>¿Cuál?</label>
          <input type="text" class="form-control form-control-sm" name="cargo_otro_persona" [(ngModel)]="nueva_persona.cargo_otro" placeholder="Ej.: Capitán" />
        </div>
        <div class="col-md-6 col-lg-2 mb-2">
          <label>Equipo <small class="text-grey-m1">(opcional)</small></label>
          <select class="form-control form-control-sm" name="equipo_persona" [(ngModel)]="nueva_persona.id_equipo">
            <option [ngValue]="null">Sin equipo</option>
            <option *ngFor="let e of equipos" [ngValue]="e.id">{{e.nombre}} - {{e.categoria?.nombre}}</option>
          </select>
        </div>
        <div class="col-md-6 col-lg-1 mb-2">
          <button class="btn btn-sm btn-success btn-block" type="button" (click)="agregarDestinatarioManual()">
            <i class="fa fa-plus mr-1"></i>Agregar
          </button>
        </div>
      </div>
      <small class="text-grey-m1">
        Con equipo, las variables {{'{'}}equipo{{'}'}}, {{'{'}}categoria{{'}'}}, {{'{'}}disciplina{{'}'}} y el logo del equipo se llenan solos.
        Use {{'{'}}cargo{{'}'}} en la plantilla para el cargo (a los jugadores les dice "Jugador").
        Estas personas no se guardan en el sistema: quedan solo en este navegador para este campeonato.
      </small>
    </div>
    <div *ngIf="plantillas.length==0" class="cert-aviso mb-2">
      <i class="fas fa-info-circle text-blue mr-1"></i>Primero diseñe y guarde una plantilla en la pestaña "Diseño de plantillas".
    </div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span>{{jugadoresSeleccionados().length}} de {{jugadoresFiltrados().length}} personas seleccionadas</span>
      <button class="btn btn-danger" type="button" [disabled]="plantillas.length==0 || jugadoresSeleccionados().length==0" (click)="generarCertificados()">
        <i class="fa fa-file-pdf mr-1"></i>Generar PDF
      </button>
    </div>
    <div class="table-responsive cert-tabla">
      <table class="table text-dark-m2 text-95 table-bordered table-hover table-striped">
        <thead class="bgc-white text-grey text-uppercase text-80">
          <tr>
            <th class="center">
              <input type="checkbox" name="todos_jugadores" [ngModel]="todosSeleccionados()" (ngModelChange)="seleccionarTodos($event)" />
            </th>
            <th>N°</th>
            <th>Nombre</th>
            <th>CI</th>
            <th>Cargo</th>
            <th>Equipo</th>
            <th>Categoría</th>
            <th>Disciplina</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let je of jugadoresFiltrados(); let i=index;" [class.cert-fila-manual]="je.manual">
            <td class="center"><input type="checkbox" name="jugador_{{je.id}}" [(ngModel)]="je.seleccionado" /></td>
            <td>{{i+1}}</td>
            <td>{{je.jugador.persona.nombre_completo}}</td>
            <td>{{je.jugador.persona.ci}}</td>
            <td>
              <span *ngIf="je.manual" class="badge badge-info">{{je.cargo}}</span>
              <span *ngIf="!je.manual" class="text-grey-m1">Jugador</span>
            </td>
            <td>{{je.equipo.nombre}}</td>
            <td>{{je.equipo.categoria?.nombre}}</td>
            <td>{{je.equipo.disciplina?.nombre}}</td>
            <td class="center">
              <a *ngIf="je.manual" href="javascript:void(0)" class="text-danger" title="Quitar de la lista" (click)="quitarDestinatarioManual(je)">
                <i class="fa fa-trash-alt"></i>
              </a>
            </td>
          </tr>
          <tr *ngIf="jugadoresFiltrados().length==0">
            <td colspan="9" class="text-center text-grey-m1">No hay personas con estos filtros.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
